import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { DropdownMenuItem, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger } from "@/components/ui/dropdown-menu";
import type { AgentSkill, AgentSkillsStatus } from "@/hooks/use-agent-skills";

export function ComposerSkillPicker({ status, skills, selected, limitReached, disabled, onToggle }: {
  status: AgentSkillsStatus;
  skills: AgentSkill[];
  selected: string[];
  limitReached: boolean;
  disabled: boolean;
  onToggle: (name: string) => void;
}) {
  const { t } = useTranslation("chat");
  if (status === "unavailable") return null;
  return <DropdownMenuSub>
    <DropdownMenuSubTrigger disabled={disabled} aria-label={t("composerSkills.menu")}>{t("composerSkills.menu")}</DropdownMenuSubTrigger>
    <DropdownMenuSubContent className="max-h-72 min-w-56 max-w-80 overflow-y-auto">
      {status === "loading" ? <DropdownMenuItem disabled>{t("composerSkills.loading")}</DropdownMenuItem>
        : skills.length === 0 ? <DropdownMenuItem disabled>{t("composerSkills.empty")}</DropdownMenuItem>
          : skills.map((skill) => {
            const checked = selected.includes(skill.name);
            return <DropdownMenuItem key={skill.name} disabled={!checked && limitReached} onSelect={() => onToggle(skill.name)} aria-label={t(checked ? "composerSkills.deselect" : "composerSkills.select", { name: skill.name })}>
              <span className="flex min-w-0 flex-1 flex-col"><span className="truncate">{skill.name}</span>{skill.description && <span className="line-clamp-2 text-xs text-muted-foreground">{skill.description}</span>}</span>
              {checked && <Check className="ml-auto size-4 shrink-0" aria-hidden="true" />}
            </DropdownMenuItem>;
          })}
      {limitReached && <div role="status" className="px-2 py-1 text-xs text-muted-foreground">{t("composerSkills.limit", { count: 5 })}</div>}
    </DropdownMenuSubContent>
  </DropdownMenuSub>;
}
